import axios from '../base/axios';
import API_KEY from './key';

const GET_TVNEWS = 'flixfrenzy/redux/GET_TVNEWS';

// eslint-disable-next-line default-param-last
const tvNewsReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TVNEWS:
      return action.payload;
    default:
      return state;
  }
};

export const getTvNews = () => (dispatch) => {
  axios.get(`discover/tv?api_key=${API_KEY}&with_genres=10763`).then((res) => {
    dispatch({
      type: GET_TVNEWS,
      payload: res.data,
    });
  });
};

export default tvNewsReducer;
